import type { AnonymousUser } from '@blinq-types';
import { analytics } from '@modules/analytics';
// biome-ignore lint/style/noRestrictedImports: deprecated file, remove when oldCreateUser/oldUpdateUser callers are migrated (WEB-102)
import { doc, setDoc } from 'firebase/firestore';

import { collections } from './firebase';
import { sanitizeForDb, toDBUser } from './transformers';

export const fetchGclidAndFbclid = (userId: string) => {
  const gclid = localStorage.getItem('gclid') ?? undefined; // don't set to null
  const fbclid = localStorage.getItem('fbclid') ?? undefined;

  if (gclid || fbclid) {
    analytics.identify({ user_id: userId, traits: { gclid, fbclid } });
  }

  return { gclid, fbclid };
};

export const fetchGclid = (userId: string) => {
  const gclid = localStorage.getItem('gclid');

  if (gclid && typeof analytics !== 'undefined') {
    analytics.identify({ user_id: userId, traits: { gclid: gclid } });
    return gclid;
  }

  return undefined;
};

export const cacheUser = (user: AnonymousUser) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// Taken from firebase-api/user-api/createUser().
// Due to be deprecated.
export const oldCreateUser = async (user: AnonymousUser, cache = true): Promise<void> => {
  const docRef = doc(collections.users(), user.userId);
  // this was saved earlier in the user create flow
  // update it here just in case
  user.gclid = fetchGclid(user.userId);

  if (cache) {
    cacheUser(user);
  }

  const dbUser = toDBUser(user);

  const sanitizedDbUser = sanitizeForDb(dbUser);

  const newUser = await setDoc(docRef, sanitizedDbUser);

  return newUser;
};

// Taken from firebase-api/user-api/updateUser().
// Due to be deprecated.
export const oldUpdateUser = async (user: AnonymousUser, cache = true): Promise<void> => {
  const docRef = doc(collections.users(), user.userId);

  const { gclid, fbclid } = fetchGclidAndFbclid(user.userId);

  if (gclid) {
    user.gclid = gclid;
  }
  if (fbclid) {
    user.fbclid = fbclid;
  }

  if (cache) cacheUser(user);

  const dbUser = toDBUser(user);
  const sanitizedDbUser = sanitizeForDb(dbUser);

  return await setDoc(docRef, sanitizedDbUser, { merge: true });
};

export const createUserDoc = async (user: AnonymousUser, cache = true) => {
  await oldCreateUser(user, cache);

  /**
   * getFeatureVariant is broken if the user is an anon or not logged in,
   * so we comment out the code to just default to the old flow for now.
   */

  // const useGQL = await getFeatureVariant('schrodinger_create_update_user_doc', 'off', {
  //   userId: user.userId,
  // });

  // const token = getCookie('token');
  // const client = getGraphQLClient(token);

  // if (useGQL === 'on') {
  //   user.gclid = fetchGclid(user.userId);
  //   if (cache) {
  //     cacheUser(user);
  //   }

  //   await client.request<CreateUserDocMutation, CreateUserDocMutationVariables>(
  //     CreateUserDocDocument,
  //     {
  //       input: {
  //         data: user,
  //       },
  //     },
  //   );
  // } else {
  //   await oldCreateUser(user, cache);
  // }
};

export const updateUserDoc = async (user: AnonymousUser, cache = true) => {
  await oldUpdateUser(user, cache);

  /**
   * getFeatureVariant is broken if the user is an anon or not logged in,
   * so we comment out the code to just default to the old flow for now.
   */

  // const token = getCookie('token');
  // const client = getGraphQLClient(token);

  // const useGQL = await getFeatureVariant('schrodinger_create_update_user_doc', 'off', {
  //   userId: user.userId,
  // });

  // if (useGQL === 'on') {
  //   const { gclid, fbclid } = fetchGclidAndFbclid(user.userId);

  //   if (gclid) {
  //     user.gclid = gclid;
  //   }
  //   if (fbclid) {
  //     user.fbclid = fbclid;
  //   }

  //   if (cache) cacheUser(user);

  //   await client.request<UpdateUserDocMutation, UpdateUserDocMutationVariables>(
  //     UpdateUserDocDocument,
  //     {
  //       input: {
  //         data: user,
  //       },
  //     },
  //   );
  // } else {
  //   await oldUpdateUser(user, cache);
  // }
};
